import { call, select, delay } from 'redux-saga/effects';
import { getGallectionById, getGrusername } from '../selectors';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
import { getGallectionType } from '../helpers';
function* setGallectionName(action) {
    yield delay(500); // + takeLatest = debounced
    const { folderId, name } = action.payload;
    const username = yield select(getGrusername);
    const gallection = yield select(getGallectionById, folderId);
    if (!gallection) {
        return;
    }
    var _getGallectionType;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name
    };
    yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/rename',
        data: params
    });
}
export default setGallectionName;

//# sourceMappingURL=saveChangedGallectionName.js.map